import { useMutation } from "@tanstack/react-query";
import { updateGoogleBusinessProfileAttributes } from "../../api/bReviewsApi";

export const useUpdateGoogleBusinessProfileAttributes = () => {
  return useMutation({
    mutationFn: ({ locationId, data }) =>
      updateGoogleBusinessProfileAttributes(locationId, data),
  });
};
